import { ChangeEvent, FC, useEffect, useMemo } from "react";

import { Input, Select, Tabs } from "antd";
import debounce from "lodash.debounce";

import { useAppDispatch, useAppSelector } from "store";
import { getContractsSelector } from "store/contracts/contracts.selector";
import {
  updateContractsFilter,
  updateContractsPagination,
  updateContractsSort,
} from "store/contracts/contracts.actions";
import searchIcon from "data/icons/search.svg";
import { getContracts } from "store/contracts/contracts.thunks";
import { initialState } from "store/contracts/contracts.reducer";
import { CreateContractModal } from "components/contracts";
import { statusTabs } from "./statusTabs";
// import { useContractors } from "helpers/useContractors";

import "./ContractsHeader.scss";

interface IContractsHeaderProps {
  isDocGenRoute?: boolean;
  onMonthChange?: (month: string) => void;
  selectedMonth?: string;
}

const ContractsHeader: FC<IContractsHeaderProps> = ({ isDocGenRoute = false, onMonthChange, selectedMonth }) => {
  const dispatch = useAppDispatch();
  const { filter, categories, pagination } = useAppSelector(getContractsSelector);
  // const { contractors, getContractors } = useContractors(100);

  const handleChangeStatus = (status: string) => {
    dispatch(updateContractsFilter({ ...filter, status }))
    dispatch(updateContractsPagination(1, pagination.rowsPerPage));
    dispatch(getContracts());
  }

  useEffect(() => {
    return () => {
      if (window.location.pathname.indexOf("/contracts") === -1) {
        dispatch(updateContractsFilter(initialState.filter));
        dispatch(updateContractsSort(initialState.sort));
        dispatch(updateContractsPagination(initialState.pagination.page, initialState.pagination.rowsPerPage));
      }
    }
  }, [])

  // const handleChangeType = (type: string) => {
  //   dispatch(updateContractsFilter({
  //     ...filter,
  //     type: type as "service" | "supply",
  //   }))
  //   dispatch(updateContractsPagination(1, pagination.rowsPerPage));
  //   dispatch(getContracts());
  // }

  const handleChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
    dispatch(updateContractsFilter({
      ...filter,
      search: e.target.value,
    }))
    dispatch(updateContractsPagination(1, pagination.rowsPerPage));
  }

  const handleChangeCategory = (categoryId: string) => {
    dispatch(updateContractsFilter({
      ...filter,
      category: categoryId,
    }))
    dispatch(updateContractsPagination(1, pagination.rowsPerPage));
  }

  const handleChangeMonth = (monthValue: string) => {
    onMonthChange?.(monthValue);
  }

  // const handleChangeContractor = (contractorId: string) => {
  //   dispatch(updateContractsFilter({
  //     ...filter,
  //     contractor: contractorId,
  //   }))
  //   dispatch(updateContractsPagination(1, pagination.rowsPerPage));
  // }

  const updateInfo = () => {
    dispatch(getContracts());
  }

  const debouncedResults = useMemo(() => {
    return debounce(updateInfo, 400);
  }, [])

  const categoriesOptions = useMemo(() => ([
    ...categories.map(category => ({
      value: category.id,
      label: category.name,
    })),
  ]), [ categories ])

  const monthOptions = useMemo(() => {
    const now = new Date();
    const currentMonth = now.getMonth() + 1;
    const currentYear = now.getFullYear();

    const formatMonthOption = (month: number, year: number) => {
      const monthStr = String(month).padStart(2, "0");
      const value = `${ month }/${ year }`;
      const label = `${ monthStr }/${ year }`;
      return { value, label };
    };

    return [
      formatMonthOption(currentMonth - 1 || 12, currentMonth === 1 ? currentYear - 1 : currentYear),
      formatMonthOption(currentMonth, currentYear),
      formatMonthOption(currentMonth === 12 ? 1 : currentMonth + 1, currentMonth === 12 ? currentYear + 1 : currentYear),
    ];
  }, [])

  useEffect(() => {
    // getContractors("");

    return () => {
      debouncedResults.cancel();
    }
  }, [])

  return (
    <div className="contracts-header-wrapper">
      <Tabs
        items={ statusTabs }
        activeKey={ filter.status }
        onChange={ handleChangeStatus }
      />

      <div className="contracts-search-input">
        { isDocGenRoute && (
          <Select
            options={ monthOptions }
            onChange={ (value: string) => {
              handleChangeMonth(value)
            } }
            placeholder="Month"
            style={ { minWidth: 120 } }
            value={ selectedMonth }
          />
        ) }

        <Select
          options={ categoriesOptions }
          allowClear
          onChange={ (value: string) => {
            handleChangeCategory(value)
            debouncedResults()
          } }
          filterOption={ false }
          placeholder="Category e.g. Warranty"
          style={ { minWidth: 220 } }
          value={ filter.category }
        />

        {/*<Select*/ }
        {/*  options={ contractors }*/ }
        {/*  showSearch*/ }
        {/*  allowClear*/ }
        {/*  onSearch={ (value) => getContractors(value) }*/ }
        {/*  onChange={ (value: string) => {*/ }
        {/*    handleChangeContractor(value)*/ }
        {/*    debouncedResults()*/ }
        {/*  } }*/ }
        {/*  filterOption={ false }*/ }
        {/*  placeholder="Contractor"*/ }
        {/*  style={ { minWidth: 220 } }*/ }
        {/*/>*/ }

        <Input
          value={ filter.search }
          prefix={ <img src={ searchIcon } alt=""/> }
          placeholder="Search"
          onChange={ (e) => {
            handleChangeSearch(e);
            debouncedResults()
          } }
        />

        { !isDocGenRoute && <CreateContractModal/> }
      </div>
    </div>
  )
}

export default ContractsHeader;
